/* eslint-disable no-throw-literal */
import { ACCESS_FROM, CCB_INFO } from './const';
import fetchHelper from './fetch-helper';
import config from '../config';
import { getCookie } from './common-helper.js';

// const shopId = getUrlParam('shopId');

const ccbAppHelper = {
  /**
   * @description 清除cookie
   * 进入建行环境 每次都重新登录
   */
  clearAllCookie() {
    const date = new Date();
    date.setTime(date.getTime() - 10000);
    const keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (let i = keys.length; i--;) {
        document.cookie = keys[i] + '=0; expire=' + date.toGMTString() + '; path=/';
      }
    }
  },
  isCcbEvn(path = '') {
    let _path = path;
    if (!_path) {
      _path = location.search || '';
    }
    const res = _path.match(/accessFrom=(.*?)(&|$)/);

    const accessFrom = window.sessionStorage ? window.sessionStorage.getItem('ACCESS_FROM') : ''; // 建行登录标志
    if ((res && Array.isArray(res) && res[1] === ACCESS_FROM.CCB_APP) || accessFrom === ACCESS_FROM.CCB_APP) {
      window.sessionStorage.setItem('ACCESS_FROM', ACCESS_FROM.CCB_APP);
      return !0;
    }
    return !1;
  },
  /**
   * @param str 形如a=1&b=3的字符串
   * @param param 需要解构的字段
   * 获取a=1&b=3中的某个字段
   */
  getParam(str = '', param) {
    // MERCHANTID=105451058149876&POSID=041638808&BRANCHID=370617001&ORDERID=CPRG31067679&PAYMENT=145.43
    // &CURCODE=01&TXCODE=520100&REMARK1=&REMARK2=&TYPE=1&PUB=22b39f606e7c7f265572d605020111&GATEWAY=0
    // &CLIENTIP=&REGINFO=&PROINFO=%u5c0f%u6797%u6d4b%u8bd5%2d%u6d88%u8d39&REFERER=&MAC=315d9e7ccfa02db98015c8c051980ca2
    const reg = new RegExp(`(^|&)${param}=([^&]*)(&|$)`, 'i');
    const r = str.match(reg);
    if (!r) return null;
    return r[2];
  },
  /**
   * 解密密文
   */
  decodeCipherText(ccbParamSJ = '') {
    return fetchHelper
      .get(config.decodeCipherTextForCCB, {
        ccbParamSJ,
      })
      .then(data => {
        if (data === null || data === '') {
          throw { code: '5001', msg: '解密后内容为空' };
        }
        try {
          // return JSON.parse(result || '');
          const userId = ccbAppHelper.getParam(data, 'userid') || '';
          const mobile = ccbAppHelper.getParam(data, 'mobile') || '';
          return {
            userId,
            mobile,
          };
        } catch (ex) {
          throw { code: '5002', msg: '解密后内容结构异常' };
        }
      });
  },
  /**
   * 获取建行App登录的人员信息
   */
  getUserInfo(ccbParamSJ = '') {
    const param = decodeURIComponent(ccbParamSJ);
    return ccbAppHelper.decodeCipherText(param).then(data => {
      if (!data || !data.userId || !data.mobile) {
        throw { code: '5003', msg: '解密后内容信息不正确' };
      }
      return data;
    });
  },
  login(info) {
    const { shopId, ccbParamSJ } = info;
    return fetchHelper
      .get(config.loginInCCBAppAPI, { shopId, ccbParamSJ: decodeURIComponent(ccbParamSJ), nationTelCode: '86', fromBrand: false })
      .then((data = {}) => {
        const { ccbParam = '' } = data;
        if (ccbParam === null || ccbParam === '') {
          throw { code: '5001', msg: '登录后返回参数为空' };
        }
        try {
          const userId = ccbAppHelper.getParam(ccbParam, 'userid') || '';
          const mobile = ccbAppHelper.getParam(ccbParam, 'mobile') || '';
          return {
            userId,
            mobile,
          };
        } catch (ex) {
          throw { code: '5002', msg: '解密后内容结构异常' };
        }
      })
      .catch(ex => {
        throw ex;
      });
  },

  /**
   * 判断用户是否登录
   */
  getUserIndividual(info) {
    const storgeCcbParamSJ = window.sessionStorage && window.sessionStorage.getItem(CCB_INFO.CCB_PARAM_SJ);
    if (storgeCcbParamSJ) return Promise.resolve();
    const { shopId, ccbParamSJ, errMsg } = info;
    if (!ccbParamSJ) {
      throw errMsg;
    }
    return ccbAppHelper
      .login({ shopId, ccbParamSJ })
      .then(userInfo => {
        if (window.localStorage) {
          localStorage.setItem(CCB_INFO.CCB_USER_INFO, JSON.stringify(userInfo));
          sessionStorage.setItem(CCB_INFO.CCB_PARAM_SJ, ccbParamSJ);
        }
        return true;
      })
      .catch(ex => {
        throw ex;
      });
  },

  /**
   * 根据跳转接口报文头CloudMercWebView-User-Agent判断当前是ios还是Android
   */
  checkIosOrAndroid() {
    const ccbSys = localStorage.getItem('CCB_SYS'); // 当前系统 安卓/ios
    if (ccbSys) return ccbSys;
    const { CCB_HEADER, CCB_HEADER_IOS, CCB_HEADER_ANDROID } = CCB_INFO;
    const CloudMercWebView = getCookie(CCB_HEADER) && getCookie(CCB_HEADER).toLowerCase();
    ccbAppHelper.showEle(`==getCookie CloudMercWebView: ${CloudMercWebView}--`);
    if (!CloudMercWebView) {
      ccbAppHelper.showEle('==无法获取cookie CloudMercWebView-User-Agent--');
      return CCB_HEADER_IOS;
    }
    if (CloudMercWebView.indexOf(CCB_HEADER_IOS) > -1) {
      localStorage.setItem('CCB_SYS', CCB_HEADER_IOS);
      ccbAppHelper.showEle(`==CCB_SYS: ${CCB_HEADER_IOS}--`);
      return CCB_HEADER_IOS;
    }
    if (CloudMercWebView.indexOf(CCB_HEADER_ANDROID) > -1) {
      localStorage.setItem('CCB_SYS', CCB_HEADER_ANDROID);
      ccbAppHelper.showEle(`==CCB_SYS: ${CCB_HEADER_ANDROID}--`);
      return CCB_HEADER_ANDROID;
    }
  },

  showEle(msg) {
    // 使用 ccbAppHelper.showEle('xxxx');
    // 建行环境不好调试 解除以下注释可将所有错误打印在支付页

    // let $showErr = document.getElementById('showErr');
    // if (!$showErr) {
    //   const ele = document.createElement('div');
    //   ele.id = 'showErr';
    //   ele.style.position = 'absolute';
    //   ele.style.left = '0';
    //   ele.style.top = '100px';
    //   ele.style.width = '100%';
    //   ele.style.wordBreak = 'break-word';
    //   $showErr = ele;

    //   document.body.appendChild($showErr);
    // }
    // let e = document.createElement('p');
    // e.innerHTML = msg;
    // $showErr.appendChild(e);
    // e = null;
  },

  /**
   * 支付字符串截取重组操作
   * @param str 为pay/ccbPay.json返回的url
   */
  getPayInfoStr(payinfoStr) {
    // MERCHANTID=105451058149876&POSID=041638808&BRANCHID=370000000&ORDERID=CPRG31069850&PAYMENT=0.01
    // &CURCODE=01&TXCODE=520100&REMARK1=&REMARK2=YS44000010000023&TYPE=1&PUB=22b39f606e7c7f265572d605020111
    // &GATEWAY=0&CLIENTIP=&REGINFO=&PROINFO=%u5c0f%u6797%u6d4b%u8bd5%2d%u6d88%u8d39&REFERER=
    // &THIRDAPPINFO=comccbpay1234567890cloudmerchant&PAYMAP=0101000000&FRZTIME=
    if (!payinfoStr) return;
    const PAYMAP = ccbAppHelper.getParam(payinfoStr, 'PAYMAP');
    let payinfo = payinfoStr.replace(/&PAYMAP=[^&]*/, ''); // 去除PAYMAP后的字串
    if (window.localStorage) {
      const userInfoStr = localStorage.getItem(CCB_INFO.CCB_USER_INFO);
      const userInfo = userInfoStr ? JSON.parse(userInfoStr) : null;
      if (userInfo) {
        payinfo = `${payinfo}&PHONENO=${userInfo.mobile}&KIKID=${userInfo.userId}&PAYMAP=${PAYMAP}`;
      }
    }
    return payinfo;
  },

  /**
   * 唤起支付
   * @param conf 为支付传入的参数字符串payinfo和returnUrl
   */
  ccbPayFor(conf = {}) {
    const { payinfo, returnUrl = '' } = conf;
    const payinfoStr = ccbAppHelper.getPayInfoStr(payinfo);
    if (!payinfoStr) {
      ccbAppHelper.showEle('==ccbPayFor 唤起支付 无法获取payinfo--');
      // throw { code: '5003', msg: '无法支付所需payinfo' };
      // location.href = returnUrl;
      // return;
    }
    const sys = ccbAppHelper.checkIosOrAndroid();
    ccbAppHelper.showEle(`==当前系统${sys}, 重组后的payinfoStr: ${payinfoStr}--`);
    const remark2 = ccbAppHelper.getParam(payinfo, 'REMARK2'); // 获取支付参数REMARK2供CCBBridge.requestNative使用
    if (!remark2) {
      ccbAppHelper.showEle('==ccbPayFor--无法获取remark2--');
      // location.href = returnUrl;
      // throw { code: '5003', msg: '获取REMARK2失败' };
      // return;
    }
    ccbAppHelper.activeForH5AndCcb(remark2, returnUrl); // 支付完成后的回调
    ccbAppHelper.showEle('==支付完成回调设置成功--');

    const { CCB_HEADER_IOS, CCB_HEADER_ANDROID } = CCB_INFO;
    if (sys === CCB_HEADER_IOS) {
      ccbAppHelper.showEle('==应该唤起ios支付--');
      window.location = `mbspay://direct?${payinfoStr}`; // ios唤起支付
    } else if (sys === CCB_HEADER_ANDROID) {
      ccbAppHelper.showEle('==应该唤起安卓支付--');
      window.mbspay.directpay(payinfoStr); // 安卓唤起支付
    }
  },
  /**
   * 与建行APP交互 支付后的回调场景
   */
  activeForH5AndCcb(remark2 = '', returnUrl = '') {
    // 支付完成后重新回到移动门店 session被清除了 需要重新写入标识
    const accessFrom = sessionStorage.getItem('ACCESS_FROM');
    const ccbParamSJ = sessionStorage.getItem('CCB_PARAM_SJ');
    const backUrl = `${decodeURIComponent(returnUrl)}&accessFrom=${accessFrom}&ccbParamSJ=${ccbParamSJ}`;
    ccbAppHelper.showEle(`==backUrl--${backUrl}`);

    const callbackName = 'portalCcbPayCallback';
    const params = {
      action:'setCache',
      params: {
        key: remark2, // 回调的key，同下单参数的remark2
        value: backUrl, // 回调的url，支付成功后云商APP根据key跳转场景方url
      },
    };
    if (!window.CCBBridge) {
      ccbAppHelper.showEle('==window.CCBBridge undefined--');
      throw { code: '5003', msg: 'window.CCBBridge undefined' };
      // location.href = returnUrl;
      // return;
    }
    ccbAppHelper.showEle('==正在设置支付回调--');
    ccbAppHelper.showEle(`${backUrl}`);
    window[callbackName] = result => {
      ccbAppHelper.showEle('支付成功后回调结果：');
      ccbAppHelper.showEle(result);
    };
    window.CCBBridge.requestNative(JSON.stringify(params), callbackName);
  },
};

export default ccbAppHelper;



// WEBPACK FOOTER //
// ./src/helper/Ccb-app-helper.js